(() => {
  const desktopPointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const staticCopySelector = [
    '.beambox-home__section-title',
    '.beambox-products__group-title',
    'beambox-about .about-intro',
    'beambox-about .about-section-title',
    'beambox-about .about-brand-film__content',
  ].join(',');

  const keepTitleClickLocal = (event) => {
    if (!desktopPointer.matches || !(event.target instanceof Element)) return;
    if (!event.target.closest(staticCopySelector)) return;
    if (event.target.closest('a, button, input, select, textarea, summary, [contenteditable]')) return;

    // Do not cancel the browser default. Double-click selection and copying stay native;
    // only the event propagation that can wake unrelated global gesture scripts is stopped.
    event.stopImmediatePropagation();
  };

  ['pointerdown', 'mousedown', 'pointerup', 'mouseup', 'click', 'dblclick'].forEach((eventName) => {
    window.addEventListener(eventName, keepTitleClickLocal, true);
  });
})();
